import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);
const KEY = "mcanime_wishlist";
const readLocal = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export function WishlistProvider({ children }) {
  const { user, loading } = useAuth();
  const [ids, setIds] = useState(readLocal);

  useEffect(() => {
    if (loading) return;
    if (!user) return setIds(readLocal());
    const local = readLocal();
    (local.length ? api.post("/wishlist/merge", { ids: local }) : api.get("/wishlist"))
      .then(({ data }) => { setIds(data.ids); localStorage.removeItem(KEY); })
      .catch(() => {});
  }, [user, loading]);

  const toggle = async (id) => {
    const had = ids.includes(id);
    const next = had ? ids.filter((x) => x !== id) : [...ids, id];
    setIds(next);
    if (!user) return localStorage.setItem(KEY, JSON.stringify(next));
    try {
      if (had) await api.delete(`/wishlist/${id}`);
      else await api.put(`/wishlist/${id}`);
    } catch {
      setIds(ids);
      toast.error("Preferiti non aggiornati, riprova");
    }
  };

  return (
    <WishlistContext.Provider value={{ ids, count: ids.length, has: (id) => ids.includes(id), toggle }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
